<app-header></app-header>
<section class="container-xxl">
  <div class="breadcrumb-area">
    <nav aria-label="breadcrumb mb-0">
      <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </nav>  
  </div>
  <div id="section-New"></div> 
  <div class="inner-page-sidedetails">
    <div class="details">
      <div class="description">
        <div class="news mb-3"> 
          <div class="row">
            <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
              <div [style]="navmenuloadCss">
                  <app-plugin-navbar [datacollection]="{data:P_data}" *ngIf="showNavComponent"></app-plugin-navbar>
                </div>
          </div>
          <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
              <div class="inner-banner-image">
                <div class="image-area">
                    <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                </div> 
            </div>
              <div class="info-box">
                <div class="row">
                  <div class="col-lg-12">
                    <!-- Contact Wrap Start -->
                <div class="contact-sec">
                    <div class="row">
                        <div class="col-xxl-10 col-xl-12 col-lg-12 mx-auto">
                            <!-- Contact Form Start -->
                            <div class="contact-form my-xxl-5 my-xl-5 my-4">
                                <div class="contact-form-wrap">
                                    <div class="title heading-wrap section-heading">
                                        <h2 class="screen-reader">{{ 'FeedbackForm' | translate }}</h2>
                                        <div class="custom-border mt-2 text-center" style="margin: 0 auto;"></div>
                                    </div>
                                    <div class="alert alert-success screen-reader"
                                    style="text-align: center;" role="alert" *ngIf="status">
                                    {{sucess_message}}</div>
                                    <form action="#" [formGroup]="FeedbackForm" (ngSubmit)="submitFeedback()">
                                        <div class="row">
                                          
                                            <div class="col-sm-12 col-md-12 col-lg-6">
                                                <div class="single-form">
                                                    <div class="contact-ic"><i class="bi bi-person"></i> </div>
                                                    <input type="text" placeholder="{{'Name'|translate}} *" class="form-control screen-reader" name="name" id="name" formControlName="name" autocomplete="off" >
                                                    <span class="lab-invalid text-danger screen-reader" *ngIf="name && name.invalid && name.touched">Name field is
                                                      not valid</span>
                                                </div>
                                                
                                            </div>
                                           
                                            <div class="col-sm-12 col-md-12 col-lg-6">
                                                <div class="single-form">
                                                    <div class="contact-ic"><i class="bi bi-envelope"></i> </div>
                                                    <input type="email" placeholder="{{'EmailId'|translate}} *" class="form-control screen-reader" name="email" id="email" formControlName="email" autocomplete="off">
                                                    <span class="lab-invalid text-danger screen-reader" *ngIf="email && email.invalid && email.touched">Email Id field is
                                              not valid</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-12 col-lg-6">
                                                <!-- Single Form Start -->
                                                <div class="single-form">
                                                    <div class="contact-ic"><i class="bi bi-pencil"></i> </div>
                                                    <textarea placeholder="{{'Suggestion'|translate}}"
                                                    class="form-control screen-reader" name="comments" id="comments" formControlName="comments" ></textarea>
                                                </div>
                                                <!-- Single Form End -->
                                            </div>
                                              <div class="col-sm-12 col-md-12 col-lg-6">
                                                  <div class="position-relative">
                                                    <div class="captcha-box">
                                                      <div class="captcha screen-reader">
                                                        <img *ngIf="captchaImgDisplay" src="{{captchaImg}}" id="captchaImage"
                                                            class="mb-0" alt="captcha">
                                                        <a href="javascript:void(0);" class="text-orange" data-bs-toggle="tooltip" [attr.title]="language=='English'?'Refresh Captcha':'कैप्चा रिफ्रेश करें'" (click)="reloadCaptcha()"><i class="bi bi-arrow-clockwise"></i></a>
                                                      </div>
                                                      <div class="single-form mb-0">
                                                        <input type="text" maxlength="50" class="form-control screen-reader" value="" onfocus="this.select();"
                                                        id="captcha" name="captcha" formControlName="captcha" placeholder="{{'EnterCaptcha'|translate}}" autocomplete="off"
                                                        [attr.data-val]="captchaData">
                                                        <span class="lab-invalid text-danger screen-reader" *ngIf="captcha && captcha.invalid && captcha.touched">Captcha is
                                                          not valid</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                 
                                               </div>
                                                <!-- Single Form Start -->
                                                <div class="single-form screen-reader">
                                              
                                                </div>
                                              <!-- Single Form End -->
                                           
                                          <div class="row">
                                            <div class="col-sm-6 col-md-5 mx-auto">
                                                <!--  Single Form Start -->
                                                <div class="form-btn">
                                                    <button class="btn btn-3 screen-reader" [attr.title]="language=='English'?'Submit':'जमा करें'" type="submit" [disabled]="FeedbackForm.invalid">{{'Submit'|translate}}</button>
                                                </div>
                                                <!--  Single Form End -->
                                            </div>
                                          </div>
                                    </form>
                                </div>
                            </div>
                            <!-- Contact Form End -->
                        </div>
                      </div>
                     </div>
                <!-- Contact Wrap End -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-clients></app-clients>
<app-footer></app-footer>